const Alerts = require('lib/alerts');
var template = require('employer/templates/payroll/stepOne/PayrollDetail.html');

module.exports = Backbone.View.extend({
    tagName:   'tr',
    className: 'tr-md payroll-detail',

    events: {
        'change input':            'updateModel',
        'focus input':             'onFocus',
        'click .js-remove-button': 'destroyModel'
    },

    initialize: function() {
        this.$el.toggleClass('is-default', !this.model.isAdditional());
        this.$el.toggleClass('is-locked', this.model.isLocked());
        this.model.on('change', this.render, this);
        this.model.on('destroy remove', this.remove, this);

        this.render();

        return this;
    },

    render: function() {
        this.$el.html(template({model: this.model}));

        return this;
    },

    onFocus: function(ev) {
        this.$(ev.currentTarget).select();
    },

    updateModel: function(ev) {
        ev.preventDefault();

        const $el = this.$(ev.currentTarget);
        const attr = $el.attr('name');
        let val = $el.val() || 0;

        if (['unit', 'rate', 'amount'].indexOf(attr) >= 0) {
            val = parseFloat(val);
        }

        this.model.set(attr, val);
        this.model.set('isManuallyAdjusted', true);
    },

    destroyModel: function(ev) {
        ev.preventDefault();

        if (!this.model.get('isAdditional')) {
            Alerts.show('error', {
                text: 'This item is part of the employee\'s employment ' +
                    'contract, it can\'t be deleted'
            });

            return;
        }

        this.model.destroy();
    },

    remove: function() {
        Backbone.View.prototype.remove.apply(this, arguments);

        this.model.off(null, null, this);
        this.undelegateEvents();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepOne/PayrollDetail.js